module.exports = __webpack_public_path__ + "static/media/verify-ds-isvalid.8b43cede.svg";